import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from 'utils/styles';
import RichTextHeadline from '../shared/RichTextHeadline/RichTextHeadline';
import RichTextList from '../shared/RichTextList/RichTextList';
import { CardContentClassNames, CardContentProps } from './types';
import Eyebrow from '../shared/Eyebrow/Eyebrow';

const CardContent = ({
  sys,
  showFiveStarEyebrow,
  showChimeLogo,
  eyebrow,
  headline,
  copy,
  className,
  testId,
}: CardContentProps) => {
  const internalClassNames: CardContentClassNames = {
    wrapper: cn('mx-6 sm:mx-12 flex-1 flex flex-col gap-4', className?.wrapper),
    header: {
      wrapper: cn('flex flex-col gap-4', className?.header?.wrapper),
      eyebrow: cn('empty:hidden mb-0', className?.header?.eyebrow),
      headline: cn('text-heading-md font-sans font-semibold', className?.header?.headline),
    },
    copy: cn('font-serif text-body-serif', className?.copy),
  };

  const testFixture = `${testId ?? 'card'}-content`;

  return (
    <div className={internalClassNames.wrapper} data-testid={`${testFixture}-wrapper`}>
      <div className={internalClassNames.header.wrapper}>
        <Eyebrow
          sys={sys}
          showFiveStars={showFiveStarEyebrow}
          eyebrowChimeLogo={showChimeLogo}
          eyebrowText={eyebrow}
          className={internalClassNames.header.eyebrow}
        />

        {headline ? (
          <div
            className={internalClassNames.header.headline}
            data-testid={`${testFixture}-headline`}
            {...liveUpdateAttrs(sys?.id, 'headline')}>
            <RichTextHeadline headline={headline} level="h3" />
          </div>
        ) : null}
      </div>

      {copy ? (
        <div
          className={internalClassNames.copy}
          data-testid={`${testFixture}-copy`}
          {...liveUpdateAttrs(sys?.id, 'copy')}>
          <RichTextList item={copy} />
        </div>
      ) : null}
    </div>
  );
};

export default CardContent;
